import { createSlice } from "@reduxjs/toolkit";
import { NotificationType } from "./Types";

type initialstateType = {
    notificationList: NotificationType[];
    status: {
        notificationListLoading: boolean;
    };
}

var initialState: initialstateType = {
    notificationList: [],
    status: {
        notificationListLoading: false,
    }
};

const notificationSlice = createSlice({
    name : "notification",
    initialState : initialState,
    reducers : {
        setNotificationList: (state, action) => {
            state.notificationList = action.payload; 
        },
        setNotificationListLoading: (state, action) => {
            state.status.notificationListLoading = action.payload; 
        },
    }
})

export const notificationSliceReducer = notificationSlice.reducer;
export const notificationSliceAction = notificationSlice.actions;